import {
  FETCH_USER_BALANCE_SUCCESS,
  FETCH_USER_BALANCE_ASYNC_START,
  FETCH_USER_BALANCE_ASYNC_END,
  REQUEST_PAYMENT_ASYNC_START,
  REQUEST_PAYMENT_ASYNC_END,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function teachersList(state = {}, action) {
  switch (action.type) {
    case FETCH_USER_BALANCE_ASYNC_START:
      return dotProp(state)
        .set(`aSyncCall`, true)
        .value()

    case REQUEST_PAYMENT_ASYNC_START:
      return dotProp(state)
        .set(`rechargeRequestAsyncCall`, true)
        .value()

    case FETCH_USER_BALANCE_ASYNC_END:
      return dotProp(state)
        .set(`aSyncCall`, false)
        .value()

    case REQUEST_PAYMENT_ASYNC_END:
      return dotProp(state)
        .set(`rechargeRequestAsyncCall`, false)
        .value()

    case FETCH_USER_BALANCE_SUCCESS:
      return dotProp(state)
        .set(`balance`, action.balance)
        .set(`coins`, action.coins)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userBalance.js